

<car-summary (callback_products)="setProductsShoppingCart($event)"></car-summary>
